import {httpService, postMessageService} from "@/modules/common/services";

const getStaff = async () => {

  const res = await httpService.get('staffs');
  if (res.status === "OK") {
    return {staff: res.data};
  } else {
    return {error: res.message};
  }  
  // return new Promise((resolve, reject) => {
  //   postMessageService.postAndListen({message: 'get_staffs'},(res) => {
  //     console.log('post message service listen!!', res)
  //     if (res.data?.message?.event === "got-staffs" ) {
  //       console.log('got staffs!!', res.data.message.data)
  //       resolve({staff: res.data.message.data})
  //     }
  //   })
  // })

};

const getCollaborators = async (uid) => {
  const res = await httpService.get(`business/clients/v1/matters/${uid}/collaborators`, {new_api: true});

  if (res.success) {
    return res.data.collaborators;
  } else {
    return {error: res.errors[0].message};
  }
};

export default {
  getStaff,
  getCollaborators
}
